import { OrderCostSummaryV2PdfProps } from "../index";
import React from "react";
import { Text, View } from "@react-pdf/renderer";
import OrderPolicy from "../../../../../policies/OrderPolicy";

const CostingVersion = (props: OrderCostSummaryV2PdfProps) => {
  const { styles, cost, currentCostingVersion, user } = props;
  const { ecquote_version } = cost.data;

  if (!ecquote_version || !OrderPolicy.canViewEcQuoteVersion(user)) {
    return null;
  }

  return (
    <View style={styles.footer}>
      <View style={styles.ecQuoteText}>
        <Text>
          {
            currentCostingVersion &&
            <Text>
              Costing version: {currentCostingVersion.title},&nbsp;
            </Text>
          }

          Ecquote version: {ecquote_version}
        </Text>
      </View>
    </View>
  )
}

export default CostingVersion;
